import type { VocabEntry } from "../../data/vocab/types";

/** Strip leading "de "/"het " for the lemma column — gender/article is shown
 *  separately so the same word doesn't appear twice. */
export function lemmaWithoutArticle(dutch: string): string {
  return dutch.replace(/^(de|het)\s+/i, "");
}

/** Compact English form descriptor used in the detail meta line. */
export function formBadge(entry: VocabEntry): string | null {
  switch (entry.pos) {
    case "verb":
      return entry.pastTense ? `verb · ${entry.pastTense}` : "verb";
    case "adjective":
      return entry.comparative ? `adjective · ${entry.comparative}` : "adjective";
    case "noun": {
      const head = entry.gender ? `noun (${entry.gender})` : "noun";
      return entry.plural ? `${head} · pl. ${entry.plural}` : head;
    }
    case "phrase":
      return "phrase";
    case "other":
      return "other";
    case "unknown":
      return null;
    default:
      return null;
  }
}
